import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/noimage.png'


const _withScopeId = n => (_pushScopeId("data-v-f3cb609c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  href: "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
  rel: "stylesheet"
}, null, -1))
const _hoisted_2 = { class: "search_container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "search_box",
  type: "text",
  placeholder: "キーワード検索"
}, null, -1))
const _hoisted_4 = { id: "search_result" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "検索結果がありません", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "scroll_content" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: "result.name"
}
const _hoisted_13 = {
  key: 1,
  src: "'/api/v1/image/' + result.image",
  alt: "result.name"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "あなたへのおすすめ", -1))
const _hoisted_15 = { id: "recommendation" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "scroll_content" }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  src: _imports_0,
  alt: "item.name"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ※ここに表示されるおすすめは、あなたがこれまで検索したキーワードや、登録した趣味等に基づいて表示されています。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", null, [
      _createElementVNode("div", null, [
        _createElementVNode("form", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("input", {
            type: "submit",
            value: "検索",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.searchResults.length === 0 && _ctx.search_done)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, _hoisted_7))
            : (_openBlock(), _createElementBlock("section", _hoisted_8, [
                (_ctx.searchResults.length > 0 && _ctx.search_done)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_9, "検索結果"))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: result.id
                    }, [
                      _createElementVNode("a", {
                        class: "scroll_content_item",
                        href: /profile/ + result.id
                      }, [
                        (result.image == null)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                          : (_openBlock(), _createElementBlock("img", _hoisted_13)),
                        _createElementVNode("p", null, _toDisplayString(result.name), 1)
                      ], 8, _hoisted_11)
                    ]))
                  }), 128))
                ])
              ]))
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          (_ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(_ctx.msg), 1)
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_17, [
                _createElementVNode("ul", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id
                    }, [
                      _createElementVNode("a", {
                        class: "scroll_content_item",
                        href: /profile/ + item.id
                      }, [
                        (item.image == null)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: '/api/v1/image/' + item.image,
                              alt: "item.name"
                            }, null, 8, _hoisted_21)),
                        _createElementVNode("p", null, _toDisplayString(item.name), 1)
                      ], 8, _hoisted_19)
                    ]))
                  }), 128))
                ])
              ])),
          _hoisted_22
        ])
      ])
    ])
  ], 64))
}